import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(default-layout)/layout.tsx");
